import AnalyzeService from '../../services/analyze';

// actions
export const FETCH_ANSWERS = 'FETCH_ANSWERS';

/**
 * dispara uma action que busca as alternativas através utilizados os parametros
 * de busca passados.
 * @param {*} param0 parametros de busca { customerId, surveyId, questionId }
 * @param {*} dispatch função que realiza o dispatch da action
 */
export function fetchAnswers({ customerId, surveyId, questionId }, dispatch) {
  const service = new AnalyzeService();
  const promise = service.getAlternativasFromPergunta(customerId, surveyId, questionId);
  dispatch({ type: FETCH_ANSWERS, payload: promise, meta: { customerId, surveyId, questionId }});
}
